import { observer } from "mobx-react";
import React from "react";
import { Text, Stack } from "@mantine/core";
import { Drawer } from "@mantine/core";
import { BobsWorkspace } from "../stores/BobsWorkspace";
import { EventAlert } from "./details/bobEvent";
import { CustomModalTitle } from "./details/customModalTitle";
import { IconMessage } from "@tabler/icons-react";

const EventsDrawer = observer(
  ({ bobsWorkspace }: { bobsWorkspace: BobsWorkspace }) => {
    const close = () => bobsWorkspace.setEventsDrawerIsShown(false);

    const eventsNewestFirst = bobsWorkspace.events
      .slice()
      .sort((a, b) => b.createdAtTimestamp - a.createdAtTimestamp);

    return (
      <>
        <Drawer
          position="right"
          opened={bobsWorkspace.eventsDrawerIsShown}
          onClose={close}
          title={
            <CustomModalTitle text="Notifications" icon={<IconMessage />} />
          }
        >
          <Stack gap="md">
            {eventsNewestFirst.length > 0 ? (
              eventsNewestFirst.map((event) => (
                <EventAlert key={event.id} event={event} />
              ))
            ) : (
              <Text c="dimmed">No notifications</Text>
            )}
          </Stack>
        </Drawer>
      </>
    );
  }
);

export default EventsDrawer;
